import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Modal, Table } from 'react-bootstrap';
import { useDispatch } from "react-redux";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay, faTimes } from '@fortawesome/free-solid-svg-icons';
import { CaretLeftFill, CaretRightFill, ExclamationTriangle, Link45deg, PencilFill, Search, Trash } from "react-bootstrap-icons";
import { deleteReminder, getReminder, readReminder, searchReminders } from '../store/api/ReminderAPI';
import { setDialog } from "../store/api/GetAllProduct";
import ModalReminder from '../Components/Modals/ModalReminder';
let totalPage = 0;

const ModalSearchReminders = (props) => {

    const currPage = useRef(1);
    const searchData = useRef({});
    const dateFrom = useRef();
    const dateTo = useRef();
    const { showModal, setShow } = props;
    const [searchError, setSearchError] = useState(null);
    const [reminders, getReminderList] = useState([]);
    const [popReminder, setPopReminder] = useState({ show: false });
    if (totalPage < 1) {
        const t = reminders && reminders.TotalCount ? Number(reminders.TotalCount) : 0;
        totalPage = Math.floor(t / 10) + ((t % 10) > 0 ? 1 : 0);
    }

    const dispatch = useDispatch();
    function search(reset) {
        setSearchError(null);
        const onSearchDone = (res) => {
            if (res.Error) {
                setSearchError(res.Error);
                return;
            }
            getReminderList(res);
        }
        if (reset) {
            currPage.current = 1;
            totalPage = 0;
        }
        if (dateFrom.current.input.value === "") {
            searchData.current.AlarmDate = null;
        }
        if (dateTo.current.input.value === "") {
            searchData.current.AlarmDateTo = null;
        }
        searchData.current.Skip = currPage.current - 1;
        searchData.current.Take = 10;
        searchReminders(searchData.current, onSearchDone);
    }
    const changePage = (inc) => {
        if (inc) {
            currPage.current++;
        }
        else {
            currPage.current--;
        }
        search();
    }
    const onSuccess = () => {
        //currPage.current = 1;
        totalPage = 0;
        searchReminders(searchData.current, getReminderList);
    }
    const read = (id) => {
        dispatch(readReminder(id, onSuccess));
    }
    const showReminder = (id) => {
        const onSuccess = (rem) => {
            setPopReminder({ show: true, reminder: rem, onAddEdit: () => searchReminders(searchData.current, getReminderList) });
        }
        dispatch(getReminder(id, onSuccess));
    }
    function showReminderAttachment(reminder) {
        switch (reminder.AttachmentType?.toLowerCase()) {
            case "customer":
                window.open(`/CRM/AddEditCustomer/${reminder.AttachmentID}`);
                break;
            case "pre_customer":
                window.open(`/CRM/AddEditPreCustomer/${reminder.AttachmentID}`);
                break;
            case "acc_doc":
                window.open(`/Accounting/AddEditDocument/${reminder.AttachmentID}`);
                break;
            case "install":
                window.open(`/Services/Service/${reminder.AttachmentID}/install`);
                break;
            case "repair":
                window.open(`/Services/Service/${reminder.AttachmentID}/repair`);
                break;
            default:
                const atcType = reminder.AttachmentType?.toLowerCase();
                if (atcType.includes("invoice")) {
                    const invoiceType = atcType.replace("Invoice", "").replace("Formal", "");
                    window.open(`/Sale/Invoice/${invoiceType}/${reminder.AttachmentID}/${atcType.includes("Formal")}`)
                }
        }
    }
    const close = () => {
        searchData.current = {};
        setSearchError(null);
        setShow(false);
        if (reminders === "PENDING") {
            getReminderList({ Data: [] });
        }
    }
    useEffect(() => {
        if (showModal) {
            document.documentElement.style.overflow = "hidden";
        }
        else {
            document.documentElement.style.overflow = "unset";
        }
    }, [showModal])
    return (
        <Modal size="lg" show={showModal} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>
                <span><FontAwesomeIcon icon={faCalendarDay} size="lg" /> &nbsp; جستجوی یادآوری ها</span>
                <span onClick={close} style={{ cursor: "pointer" }}><FontAwesomeIcon icon={faTimes} size="lg" /></span>
            </Modal.Header>
            <Modal.Body className='bodyStyle'>
                <ModalReminder pop={popReminder} setPop={setPopReminder} />
                {searchError && <Alert variant='danger'><ExclamationTriangle size={18} />&nbsp; {searchError}</Alert>}
                <div className='row'>
                    <div className='col-md-3 form-group'>
                        <label>نوع یادآوری:</label>
                        <select className='form-control' onChange={e => searchData.current.AttachmentTypes = e.target.value}>
                            <option value="">انتخاب کنید</option>
                            <option value="Sale,Purchase,ReturnFromSale,ReturnFromPurchase,OutOfOrder,Borrow,ReturnFromBorrow,OldParts,Resid,Havaleh,Transfer,PreSale,PrePurchase">فاکتورهای انبار</option>
                            <option value="install,repair">سرویس ها</option>
                            <option value="customer,pre_customer">مشتریان</option>
                            <option value="staff">نمایندگان/تکنسین ها/پرسنل</option>
                            <option value="acc_doc">سندهای حسابداری</option>
                            <option value="cheque">چکها</option>
                            <option value="all">عمومی</option>
                        </select>
                    </div>
                    <div className='col-md-3 form-group'>
                        <label>از تاریخ:</label>
                        <DatePicker ref={dateFrom} isGregorian={false} timePicker={false} className="form-control"

                            onChange={value => { searchData.current.AlarmDate = value.local("en").format("YYYY/MM/DD") }} />
                    </div>
                    <div className='col-md-3 form-group'>
                        <label>تا تاریخ:</label>
                        <DatePicker ref={dateTo} isGregorian={false} timePicker={false} className="form-control"

                            onChange={value => { searchData.current.AlarmDateTo = value.local("en").format("YYYY/MM/DD") }} />
                    </div>
                    <div className='col-md-3 form-group'>
                        <label>&nbsp;</label>
                        <Button className="group-Btn mt-1" style={{ display: "block" }} onClick={() => search(true)}><Search />&nbsp;جستجوی یادآوری</Button>
                    </div>
                </div>
                <Table className='mt-1'>
                    <thead>
                        <tr>
                            <th>تاریخ یادآوری</th>
                            <th>نوع یادآوری</th>
                            <th>متن یادآوری</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reminders === "PENDING" &&
                            <tr>
                                <td colSpan={4} style={{ textAlign: "center" }}><Loader type="BallTriangle" width={25} height={25} color="#bb1370" /></td>
                            </tr>
                        }
                        {reminders?.Data && Array.isArray(reminders.Data) && reminders.Data.map((item, i) =>
                            <tr key={i} className="resultTableRow">
                                <td style={{ width: "110px" }}>{item.PAlarmDate + "-" + item.AlarmHour}</td>
                                <td style={{ width: "120px" }}>{item.PAttachmentType}</td>
                                <td>{item.RemBody}</td>
                                <td style={{ width: "120px" }}>
                                    <Trash className='rowBtn' size={18} color="red" onClick={() => {
                                        dispatch(setDialog({
                                            status: 'show',
                                            arrayBtn: ['yes', 'no'],
                                            dialogTitle: 'حذف یادآوری',
                                            dialogText: 'آیا از حذف مطمئن هستید؟',
                                            okOperation: deleteReminder(item.ID, onSuccess)
                                        }))
                                    }} />
                                    &nbsp;
                                    <PencilFill className='rowBtn' size={18} color="orange" onClick={() => showReminder(item.ID)} />
                                    {Number(item.AttachmentID) > 0 && <Link45deg className='rowBtn' color="blue" size={20} onClick={() => showReminderAttachment(item)} />}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
                <div>
                    <button className="btn btn-block" style={{ padding: "2px", marginRight: "2px" }} title='صفحه قبل' disabled={currPage.current === 1} onClick={() => { changePage(false) }}><CaretRightFill size={25} /></button>
                    <span>{currPage.current + " از " + totalPage}</span><span style={{ color: "gray" }}> ({reminders.TotalCount ?? 0})</span>
                    <button className="btn btn-block" style={{ padding: "2px", marginLeft: "2px" }} title='صفحه بعد' disabled={currPage.current === totalPage} onClick={() => changePage(true)}><CaretLeftFill size={25} /></button>
                </div>
            </Modal.Body>
        </Modal >
    )
}
export default ModalSearchReminders;